import Prefixer from 'inline-style-prefixer';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const cellStyle = new Prefixer().prefix({
  container: {
    position: 'relative',
    width: '100%',
  },
  editorAddonsWrapper: {
    position: 'relative',
  },
  whiteBackground: {
    width: '100%',
    marginTop: -25,
    height: 1, // 'calc(100% - 53px)',
    position: 'absolute',
    // borderTop: '8px solid #d6d6d6',
    zIndex: 199,
    // borderBottom: `1px solid ${colors.grey3}`,
  },
  addonsContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    right: 0,
    bottom: 5,
    left: 182,
    height: 17,
  },
  attachmentContainer: {
    lineHeight: '13px',
    cursor: 'pointer',
    // right: 0,
    // position: 'absolute',
  },
  attachmentContainerNoAction: {
    lineHeight: '13px',
    cursor: 'pointer',
    border: '1px solid red',
    right: 0,
    position: 'absolute',
  },
  attachmentIcon: {
    fontSize: 22,
    height: 22,
    marginRight: 10,
    marginTop: -4,
    float: 'left',
  },
  attachmentLabel: {
    fontSize: 14,
    color: colors.grey6,
  },
  uploaderContainer: {
    width: '100%',
  },
});

export default cellStyle;
